<template>
  <section id="toolkit-section" test_id="toolkit-section">
    <Card>
      <div class="tw-flex tw-items-center tw-justify-between">
        <h2 class="tw-heading-2">Toolkit</h2>
        <AddToolkit v-if="isEditModeEnabled" />
      </div>
      <template v-if="toolkit && toolkit.length">
        <hr class="tw-mb-2 tw-mt-4" />
        <div class="tw-flex tw-flex-col tw-divide-y tw-divide-neutral-100">
          <ToolkitElement
            v-for="tool in toolkit"
            :key="tool.id"
            :tool="tool"
            class="tw-py-4"
          />
        </div>
      </template>
    </Card>
  </section>
</template>

<script setup>
import Card from '@/shared/components/Card.vue'
import ToolkitElement from './ToolkitElement.vue'
import AddToolkit from './AddToolkit.vue'
import { useEditProfileModeInjector } from '@/shared/composables/edit-profile-mode/useEditProfileModeInjector.js'

defineProps({
  toolkit: {
    type: Array,
    required: true,
  },
})

const { isEditModeEnabled } = useEditProfileModeInjector()
</script>
